import { render, staticRenderFns } from "./taskection.vue?vue&type=template&id=ae722276&scoped=true&"
import script from "./taskection.vue?vue&type=script&lang=js&"
export * from "./taskection.vue?vue&type=script&lang=js&"
import style0 from "./taskection.vue?vue&type=style&index=0&id=ae722276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae722276",
  null
  
)

export default component.exports